module.exports = __webpack_public_path__ + "img/trash.f47044a3.svg";